import { cn } from "@utils/tailwind.util";

interface CreateOrEditCompanyHeaderProps {
  isExistingCompany: boolean;
  hasError?: boolean;
  onRetry?: VoidFunction;
  onClick?: VoidFunction;
}

export function CreateOrEditCompanyHeader({
  isExistingCompany,
  hasError,
  onRetry,
  onClick,
}: CreateOrEditCompanyHeaderProps) {
  const handleClick = () => {
    if (hasError || !isExistingCompany) return;
    onClick?.();
  };

  return (
    <div
      className={cn(
        "h-6 flex items-center justify-center",
        hasError
          ? cn(
              "mx-2 mt-1 rounded text-xs",
              "bg-yellow-100 text-black",
              "dark:bg-yellow-900 dark:text-white",
              "dark:ring-1 dark:ring-inset dark:ring-yellow-600",
            )
          : cn(
              "w-full bg-gray-200 text-grayOpacity70",
              "dark:bg-gray-600 dark:text-white80",
              isExistingCompany && cn(
                "cursor-pointer bg-teal-200 text-teal-600",
                "hover:bg-teal-400 hover:text-white80",
                "dark:bg-teal-700 dark:text-teal-200",
                "dark:hover:bg-teal-800 dark:hover:text-white80",
              ),
            ),
      )}
      onClick={handleClick}
    >
      {hasError ? (
        <span>
          Failed to check Meridian —{" "}
          <a
            className="underline cursor-pointer hover:opacity-70"
            onClick={onRetry}
          >
            Retry
          </a>
        </span>
      ) : (
        <span className={cn({ "cursor-pointer": isExistingCompany })}>
          {isExistingCompany ? "View in Meridian" : "Company not in Meridian"}
        </span>
      )}
    </div>
  );
}
